export enum InlineNotificationType {
  error = 'error',
  warning = 'warning',
}
